import type { SxProps, Theme } from "@mui/material/styles";

import { isDarkMode } from "@/src/theme/helpers";

/** Outer list surface for the notification panel. */
export const notificationPanelRootSx =
  (isMobile: boolean): SxProps<Theme> =>
  (muiTheme) => ({
    width: isMobile ? "100%" : 560,
    height: isMobile ? "100%" : 871,
    backgroundColor: muiTheme.palette.background.paper,
    ...(!isMobile && { overflowY: "auto" })
  });

/** Title and "mark all as read" block above the list, inset on all four sides. */
export const notificationPanelHeaderSx: SxProps<Theme> = {
  m: 2
};

/**
 * "Mark all as read" action above the list. `color="primary"` resolves to the
 * deep burnt brand red in dark mode, which only reaches ~2.9:1 on the panel
 * surface, so dark mode reads Text/Primary instead. Light mode keeps the brand
 * red, which has the contrast to work on white.
 */
export const notificationMarkAllReadSx: SxProps<Theme> = (muiTheme) => {
  const color = isDarkMode(muiTheme)
    ? muiTheme.palette.text.primary
    : muiTheme.palette.semantic.primary.main;

  return {
    textTransform: "none",
    px: 1.25,
    ml: -1,
    color,
    "&:hover": {
      color,
      backgroundColor: muiTheme.palette.action.hover
    }
  };
};
